import { cn as e } from "../../lib/utils.es.js";
import { jsx as t } from "react/jsx-runtime";
// libs/ui-lib/src/components/ui/skeleton.tsx
function n({ className: n, ...r }) {
	return /* @__PURE__ */ t("div", {
		"data-slot": "skeleton",
		className: e("bg-accent animate-pulse rounded-md", n),
		...r
	});
}
export { n as Skeleton };
